var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7158_16008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z",
    fill: "#C04141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6217 53.3335L43.844 22.2223C43.4563 21.5384 42.8942 20.9694 42.2149 20.5736C41.5356 20.1778 40.7635 19.9692 39.9773 19.9692C39.1911 19.9692 38.419 20.1778 37.7397 20.5736C37.0604 20.9694 36.4983 21.5384 36.1106 22.2223L18.3329 53.3335C17.941 54.012 17.7356 54.7821 17.7373 55.5657C17.7391 56.3493 17.9479 57.1185 18.3427 57.7953C18.7376 58.4721 19.3043 59.0325 19.9855 59.4197C20.6667 59.8069 21.4382 60.0072 22.2217 60.0001H57.7773C58.5571 59.9993 59.3229 59.7934 59.9979 59.403C60.6729 59.0126 61.2333 58.4514 61.6229 57.7759C62.0124 57.1004 62.2174 56.3343 62.2172 55.5545C62.217 54.7748 62.0116 54.0088 61.6217 53.3335Z",
    stroke: "white",
    strokeWidth: 4.44444,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 33.3335V42.2224",
    stroke: "white",
    strokeWidth: 4.44444,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 51.1113H40.0222",
    stroke: "white",
    strokeWidth: 4.44444,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7158_16008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.c8e134c4863af03c4f82645c45146840.svg";
export { ForwardRef as ReactComponent };